import React from "react";
import styles from "./LocationMessage.module.css";

const LocationMessage = () => {
  return (
    <div className={styles.message}>
      ¡Obtén información de qué tan rápido podemos enviar tus productos! ⚡️
    </div>
  );
};

export default LocationMessage;
